<div class="max-page-width">

    <div class="row m-0 confirmation" *ngIf="!editMode">
  
      <div class="col-lg-1 col-md-12"></div>
      <div class="col-lg-10 col-md-12 mt-4">
  
        <!-- <div class="d-flex text-right justify-content-end mb-3" *ngIf="!isPrinting">
          <button class="btn btn-default btn-print" (click)="printClicked()">
            <mat-icon class="mr-3">print</mat-icon>{{ 'PrintBookingSummary' | translate }}
          </button>
        </div> -->
  
        <div class="confirmation-container" *ngIf="reservationCaseResult!=null">
          <div class="title text-center">
            <h1 class="text-danger">{{ 'WeFacedAnErrorDuringProcessingYouPayment' | translate }}</h1>
            <small> {{ 'CouldNotConfirmeYourBooking' | translate }}</small>
          </div>
  
          <div class="car-confirmed">
            <div class="row">
              <div class="col-lg-8 col-md-7">
                <div [ngClass]="(reservationCaseResult.makeModelYear == 0)?'hideClass':'ShowClass'"  class="car-details-title">{{reservationCaseResult.makeModelYear}}</div>
                <div class="row">
                  <div class="col-md-5">
                    
                    <div class="booked-class">{{reservationCaseResult.vehicleClassName}}</div>
                    <div class="car-details-img mb-3">
  
                      <!--Vehicle-->
                      <img class="img-fluid" *ngIf="reservationCaseResult.vehicleID!=null"
                        [src]="attachmentService
                    .getImageLink(reservationCaseResult.vehicleID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage)">
  
                      <!--MMY-->
                      <img class="img-fluid"
                        *ngIf="reservationCaseResult.vehicleID==null&&reservationCaseResult.makeID!=null&&reservationCaseResult.modelID!=null&&reservationCaseResult.year!=null"
                        [src]="attachmentService
                    .getMMYCarImageLink(reservationCaseResult.modelID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.MMYImage,reservationCaseResult.makeID,reservationCaseResult.modelID,reservationCaseResult.year)">
  
                      <!--Class-->
                      <img class="img-fluid"
                        *ngIf="reservationCaseResult.classID!=null&&reservationCaseResult.makeID==null&&reservationCaseResult.vehicleID==null"
                        [src]="attachmentService
                    .getImageLink(reservationCaseResult.classID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.VehicleClassImg)">
                    </div>
                  </div>
                  <div class="col-md-7 mt-md-5">
                    <!-- Pickup -->
                    <div class="row mb-4">
                      <div class="col-lg-4 col-md-4 booking-pickup-dropoff">{{ 'Pickup' | translate }}</div>
                      <div class="col-lg-8 col-md-7 pl-md-0">
                        <div class="confirm-branch">{{ 'Branch' | translate }}</div>
                        <div class="detail-title ml-0">{{reservationCaseResult.fromAgencyName}}</div>
                        <div class="detail-title ml-0">{{reservationCaseResult.startDateString}}</div>
                        <div class="detail-title ml-0">{{reservationCaseResult.startTimeString}}</div>
                      </div>
                    </div>
                    <!-- Return -->
                    <div class="row mb-4">
                      <div class="col-lg-4 col-md-4  booking-pickup-dropoff">{{ 'DropOff' | translate }}</div>
                      <div class="col-lg-8 col-md-7 pl-md-0">
                      <div class="confirm-branch">{{ 'Branch' | translate }}</div>
                      <div class="detail-title ml-0">{{reservationCaseResult.toAgencyName}}</div> 
                      <div class="detail-title ml-0">{{reservationCaseResult.endDateString}}</div> 
                      <div class="detail-title ml-0">{{reservationCaseResult.endTimeString}}</div> 
                      </div>
                    </div>
                    <!-- Add-Ons -->
                    <div class="row confirm-add-ons" *ngIf="reservationCaseResult.vehicleReservationDetailsModel!=null&&reservationCaseResult.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase!=null&&reservationCaseResult.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase.length>0">
                      
                      <div class="col-lg-4 col-md-4 booking-pickup-dropoff">{{ 'Add-Ons' | translate }}</div>
  
                    <!--  <div class="">
                        <ng-container
                          *ngFor="let item of reservationCaseResult.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase">
                          {{item.serviceName}} <br />
                        </ng-container>
  
                      </div> -->
                      <div class="col-lg-8 col-md-7 row">
                        <ng-container *ngFor="let additionalService of reservationCaseResult.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase">
                          <container-element [ngSwitch]="additionalService.predefinedAdditionalServiceID">
  
                            <!--Start Additional Driver-->
                            <div class="row" *ngSwitchCase="predefinedAdditionalServiceEnum.AdditionalDrivers">
                              <div class="col-md-12 pl-md-0">
                                <div class="d-flex margins-view">
                                  <div class="detail-title ">
                                    <!-- <img class="icon-extra" [src]="attachmentService
                                      .getImageLink(
                                      additionalService.additionalServiceID
                                      ,attachmentScopesEnum.Setting
                                      , attachmentTypeEnum.AdditionalServicesIcon
                                      )"> -->
                                      <!-- <img class="icon-extra" src="assets/img/icon-extra.png" /> -->
                                    {{additionalService.serviceName}}
                                    <!-- <span class="detail-price ml-3">{{additionalService.unitPrice}} {{currency}}/ DAY</span>
                                    <div class="description">{{additionalService.description}} </div> -->
                                  </div>
                                  <span class="ml-1"> ({{additionalService.totalQuantityUsedForCase}}), </span>
                                </div>
                              </div>
                            </div>
                            <!--End Additional Driver-->
  
                            <!--Start Crossing Borders-->
                            <div class="row" *ngSwitchCase="predefinedAdditionalServiceEnum.CrossingBoarders">
                              <div class="col-md-12 pl-md-0">
                                <div class="detail-title ">
                                  <!-- <img class="icon-extra" [src]="attachmentService
                                  .getImageLink(
                                  additionalService.additionalServiceID
                                  ,attachmentScopesEnum.Setting
                                  , attachmentTypeEnum.AdditionalServicesIcon
                                  )"> -->
                                  {{additionalService.serviceName}},</div>
                                <!-- <div class="d-flex  align-items-center service-view mt-2"
                                  *ngFor="let border of additionalService.lstCrossBorderModel">
                                  <div class="crossingBorder mr-2">{{border.borderPortName}}</div>
                                  <div class="crossingBorderDescription"><span class="ml-2">Pass Permit</span><span class="ml-2">Addition
                                      Permission</span></div>
                                  <div class="ml-auto mb-2">
                                    <input disabled type="text" type="number" formControlName="BorderValue" [value]="border.charge"
                                      class="form-control form-control-number ml-auto" placeholder="0" aria-label="driverInformation">
                                  </div>
                                </div> -->
  
  
                              </div>
                            </div>
                            <!--End Crossing Borders-->
  
                            <!--Start Drivers-->
                            <div class="row" *ngSwitchCase="predefinedAdditionalServiceEnum.Drivers">
                              <div class="col-md-12 pl-md-0">
                                <div class="d-flex">
                                  <div class="detail-title ">
                                    <!-- <img class="icon-extra" [src]="attachmentService
                                    .getImageLink(
                                    additionalService.additionalServiceID
                                    ,attachmentScopesEnum.Setting
                                    , attachmentTypeEnum.AdditionalServicesIcon
                                    )"> -->
                                    {{additionalService.serviceName}}, 
                                    <!-- <span class="detail-price ml-3">{{additionalService.unitPrice}} {{currency}}/ DAY</span> -->
                                  </div>
                                </div>
                                <!-- <div class="d-flex  align-items-center service-view mt-2">
                                  <span>{{  'Skills' | translate  }}</span>
                                  <div class="crossingBorder  ml-3" *ngFor="let skill of driverSkills">{{skill.driverSkillName}}</div>
                                </div> -->
                              </div>
                            </div>
                            <!--End Drivers-->
  
                            <!--Start One Way Rental-->
                            <div class="row" *ngSwitchCase="predefinedAdditionalServiceEnum.OneWayRentalService">
                              <div class="col-md-12 pl-md-0">
                                <div class="detail-title ">
                                  <!-- <img class="icon-extra" [src]="attachmentService
                                  .getImageLink(
                                  additionalService.additionalServiceID
                                  ,attachmentScopesEnum.Setting
                                  , attachmentTypeEnum.AdditionalServicesIcon
                                  )"> -->
                                  {{additionalService.serviceName}}, </div>
                                <!-- <div class="d-flex  align-items-center service-view">
                                  <div class="crossingBorder mr-2 ">{{viewBooking.oneWayRental}}</div>
                                  <div class="ml-auto mb-2">
                                    <input disabled type="text" type="number" [value]="additionalService.unitPrice"
                                      class="form-control form-control-number ml-auto" placeholder="0" aria-label="driverInformation">
                                  </div>
                                </div> -->
                              </div>
                            </div>
                            <!--End One Way Rental-->
  
  
                            <!--Start Agent Delivery Service-->
                            <div class="row" *ngSwitchCase="predefinedAdditionalServiceEnum.RentalDelivery">
                              <div class="col-md-12 pl-md-0">
                                <div class="detail-title ">
                                  <!-- <img class="icon-extra" [src]="attachmentService
                                  .getImageLink(
                                  additionalService.additionalServiceID
                                  ,attachmentScopesEnum.Setting
                                  , attachmentTypeEnum.AdditionalServicesIcon
                                  )"> --> {{additionalService.serviceName}}, </div>
  
                                <!-- <div class="d-flex flex-wrap  align-items-center service-view" *ngIf="reservationCaseResult.isPickupAddress">
                                  <div class="mr-3">{{ 'Pickup' | translate }}</div>
                                  <div class="detail-price l-25 mr-3">{{additionalService.unitPrice}} {{currency}}/ DAY</div>
                                  <div class="mb-2 d-flex">
                                    <input disabled type="text" class="form-control" placeholder="Location in City"
                                      aria-label="Location in City" [value]="reservationCaseResult.pickupAddress">
                                  </div>
                                </div> -->
  
                                <!-- <div class="d-flex flex-wrap  align-items-center service-view" *ngIf="reservationCaseResult.isReturnAddress">
                                  <div class="mr-3">{{ 'Return' | translate }}</div>
                                  <div class="detail-price l-25 mr-3">{{additionalService.unitPrice}} {{currency}}/ DAY</div>
                                  <div class="mb-2 d-flex">
                                    <input disabled type="text"  class="form-control "
                                      placeholder="Location in City" aria-label="Location in City" [value]="reservationCaseResult.returnAddress">
                                  </div>
                                </div> -->
  
                              </div>
                            </div>
  
                            <div *ngSwitchDefault>
                              <!--IsAddOn-->
                              <div class="row" *ngIf="additionalService.isPhysicalAddon">
                                <div class="col-md-12 pl-md-0">
                                  <div class="d-flex margins-view">
                                    <div class="detail-title ">
                                      <!-- <img class="icon-extra" [src]="attachmentService
                                      .getImageLink(
                                      additionalService.additionalServiceID
                                      ,attachmentScopesEnum.Setting
                                      , attachmentTypeEnum.AdditionalServicesIcon
                                      )">  --> {{additionalService.serviceName}}
                                      <!-- <span class="detail-price ml-3">{{additionalService.unitPrice}} {{currency}}/ DAY</span>
                                      <div class="description">{{additionalService.description}} </div> -->
                                    </div>
                                    <span class="ml-1">({{additionalService.totalQuantityUsedForCase}})</span>, 
                                  </div>
                                </div>
                              </div>
                              <!-- Else-->
                              <div class="row" *ngIf="!additionalService.isPhysicalAddon">
                                <div class="col-md-12 pl-md-0">
                                  <div class="d-flex">
                                    <div class="detail-title ">
                                      <!-- <img class="icon-extra" [src]="attachmentService
                                      .getImageLink(
                                      additionalService.additionalServiceID
                                      ,attachmentScopesEnum.Setting
                                      , attachmentTypeEnum.AdditionalServicesIcon
                                      )">  --> {{additionalService.serviceName}}, 
                                      <!-- <span class="detail-price ml-3">{{additionalService.unitPrice}} {{currency}}/ DAY</span>
                                      <div class="description">{{additionalService.description}} </div> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                            </div>
  
                          </container-element>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
  
              </div>
              <div class="col-lg-4 col-md-4 booked-car-amount">
                <!-- <div>
                  <div class="booking-pickup-dropoff">{{ 'BookingNo' | translate }} </div>
                  <div class="booked-car-namber">{{reservationCaseResult.bookingNumberFormatted}}</div>
                </div> -->
                <div class="booked-car-total mt-4">
                  <div class="text-blue total-text">{{ 'TotalCharges' | translate }}</div>
                  <div class="total-num">{{reservationCaseResult.grandTotal | number}} {{currency}}</div>
                </div>
                <div class="booked-car-total">
                  <div class="text-blue total-text">{{ 'PaidAmount' | translate }}</div>
                  <div class="total-num">{{0  | number}} {{currency}}</div>
                  <!-- <div class="total-num">{{reservationCaseResult.piad  | number}} {{currency}}</div> -->

                </div>
                <div class="booked-car-total ">
                  <div class="text-blue total-text">{{ 'ContactInformation' | translate }}</div>
                  <div class="contact-text">
                    {{reservationCaseResult.fromAgencyName}}<br />
                    {{reservationCaseResult.fromAgencyPhone}}<br />
                    {{reservationCaseResult.fromAgencyEmail}}
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
  
        <div class="confirmation-footer d-flex mt-3 mb-4">
          <div class="mr-auto">
            {{ 'DownloadAPPToManageYourBookingsConfirm' | translate }}
            <div class="d-flex mt-2 confirmation-download-app">
              <a href="#"><img class="mr-2" src='assets/img/app-store.svg' /></a>
              <a href="#"><img class="" src='assets/img/google-play.svg' /></a>
            </div>
          </div>
          <!-- <div class="text-blue" *ngIf="!isPrinting">
            <a (click)="viewBooking()">{{ 'ViewBookingDetails' | translate }} <fa-icon class="ml-1"
                [icon]="faArrowAltCircleRight"></fa-icon></a>
          </div> -->
  
        </div>
  
      </div>
      <div class="col-lg-1 col-md-12"></div>
  
  
  
  
    </div>
  
    <div class="row m-0 confirmation" *ngIf="editMode&&!extendMode">
  
      <div class="col-lg-1 col-md-1"></div>
      <div class="col-lg-10 col-md-10 mt-4">
  
  
        <div class="confirmation-container mt-4">
          <div class="title text-center">
            <h1 class="text-danger">{{ 'WeFacedAnErrorDuringProcessingYouPayment' | translate }}</h1>
            <small> {{ 'CouldNotUpdateYourBooking' | translate }}</small>
          </div>
  
          <div class="confirmation-footer justify-content-center d-flex mt-3 mb-4">
  
            <div class="text-blue" *ngIf="!isPrinting">
              <a (click)="viewBooking()">{{'ViewBookingDetails' | translate }} <fa-icon class="ml-1"
                [icon]="faArrowAltCircleRight"></fa-icon></a>
            </div>
  
          </div>
  
  
        </div>
      </div>
    </div>
  
    <div class="row m-0 confirmation" *ngIf="editMode&&extendMode">
  
      <div class="col-lg-1 col-md-1"></div>
      <div class="col-lg-10 col-md-10 mt-4">
  
  
        <div class="confirmation-container mt-4">
          <div class="title text-center">
            <h1 class="text-danger">{{ 'WeFacedAnErrorDuringProcessingYouPayment' | translate }}</h1>
            <small> {{ 'CouldNotExtendeYourBooking' | translate }}</small>
          </div>
  
          <div class="confirmation-footer justify-content-center d-flex mt-3 mb-4">
  
            <div class="text-blue" *ngIf="!isPrinting">
              <a (click)="viewBooking()">{{'ViewBookingDetails' | translate }} <fa-icon class="ml-1"
                [icon]="faArrowAltCircleRight"></fa-icon></a>
            </div>
  
          </div>
  
  
        </div>
      </div>
    </div>
  
  </div>
  
  
  